const mutations = {
  setIsAuthenticated(state, value) {
    state.isAuthenticated = value;
  },
  setUser(state, value) {
    state.user = value;
  },
  setAccessToken(state, value) {
    state.accessToken = value;
  },
  setRefreshToken(state, value) {
    state.refreshToken = value;
  },
  unsetUser(state) {
    state.user = {};
    state.isAuthenticated = false;
    state.accessToken ='';
    state.refreshToken= '';
  }
};
  
const state = {
    user: {},
    isAuthenticated: false,
    accessToken: '',
    refreshToken: '',
};

const actions = {
}

  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters: { },
};
  